module.exports = __webpack_public_path__ + "static/media/EutaBiu.345bd033.mp4";